module.exports = __webpack_public_path__ + "img/home.a635a221.jpg";